const DOMAIN_NAME_REGEXP =
  /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9]))(\.[a-z0-9][a-z0-9-]{0,61}[a-z0-9])*$/;

function isDomainSearchQueryValid(query) {
  if (query === null) return false;

  return DOMAIN_NAME_REGEXP.test(query);
}

export default isDomainSearchQueryValid;
